import React, { useEffect, useState } from 'react';
import { Background, Banner } from './styles';

const IOS_DISMISS_KEY = 'installBannerDismissedAt';
const DAY_MS = 24 * 60 * 60 * 1000;

interface InstallAppIOSProps {
  disabled?: boolean;
}

function isiOS(): boolean {
  return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
}

function isStandalone(): boolean {
  return ('standalone' in window.navigator) && (window.navigator as any).standalone;
}

function hasRecentDismissal(): boolean {
  const last = localStorage.getItem(IOS_DISMISS_KEY);
  if (!last) return false;
  return Date.now() - Number(last) < DAY_MS;
}

const InstallAppIOS: React.FC<InstallAppIOSProps> = ({ disabled = false }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (disabled) {
      setShow(false);
      return;
    }

    if (isiOS() && !isStandalone() && !hasRecentDismissal()) {
      setShow(true);
    }
  }, [disabled]);

  const handleDismiss = () => {
    localStorage.setItem(IOS_DISMISS_KEY, String(Date.now()));
    setShow(false);
  };

  if (!show) return null;

  return (
    <Background role="dialog" aria-modal="true" aria-label="Instalar aplicativo">
      <Banner>
        <button className="close" onClick={handleDismiss} aria-label="Fechar aviso">×</button>
        <div>
          <img
            src="/logo-mini.png"
            alt=""
            width={24}
            height={24}
            style={{ verticalAlign: 'middle', marginRight: 8 }}
          />
          <strong>Instale a Play Moment no seu celular</strong><br />
          Toque no botão de compartilhar <strong>[</strong>🔗<strong>]</strong> e selecione <strong>“Adicionar à Tela de Início”</strong>.
        </div>
      </Banner>
    </Background>
  );
};

export default InstallAppIOS;
